module.exports = __webpack_public_path__ + "img/8_uk.7a44f587.svg";